import React from 'react'
import 'App.css';

import {AppBar, Box, Slide, Drawer, IconButton, List, ListItemButton, ListItemText, Toolbar, Typography, Button, ListItem, CardMedia, Grid } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import logo from 'img/002.png'
import border from 'img/001.png'
import 'sweetalert2/dist/sweetalert2.min.css'

import AOS from 'aos';

import HomeCom from 'component/Home'
import CheckCom from 'component/CheckFirst'
import ContactCom from 'component/Contact'

import step1 from 'img/003.png'
import step2 from 'img/007.png'
import step3 from 'img/016.png'

const drawerWidth = 240;
const navItems = ['หน้าแรก', 'จุดเด่นเมนู', 'แนะนำเข้าใช้งาน', 'สื่อประชาสัมพันธ์', 'สมมติฐานที่ใช้คำนวณ', 'คำถามที่พบบ่อย', 'ดาวน์โหลดติดตั้งแอป'];


function App() {

  const [mobileOpen, setMobileOpen] = React.useState(false);
  
  const [menuIndex, setMenuIndex] = React.useState(0);

  const AppBarRef = React.useRef(null);

  const HomeSection = React.useRef(null);
  const FeatureSection = React.useRef(null);
  const TrySection = React.useRef(null);
  const InfoSection = React.useRef(null);


  const [wh, setRealwidth] = React.useState([window.innerWidth, window.innerHeight]);
  const [scrollPosition, setScrollPosition] = React.useState(0);
  const [abHeight, setAppBar] = React.useState(0);
  const handleScroll = () => {
      const position = window.pageYOffset;
      setScrollPosition(position);
  };

  React.useEffect(() => {
    window.scrollTo(0, 0);
      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => {
          window.removeEventListener('scroll', handleScroll);
      };
  }, []);



  // React.useEffect(() => { // scroll to change
  //   if (scrollPosition >= 0 && scrollPosition < HomeSection.current.offsetTop + (wh[1] - 200)) {
  //     setMenuIndex(0)
  //   }
  //   else if (scrollPosition >= FeatureSection.current.offsetTop - AppBarHeight() && scrollPosition < TrySection.current.offsetTop - AppBarHeight()) {
  //     setMenuIndex(1)
  //   }else if (scrollPosition >= TrySection.current.offsetTop - AppBarHeight() && scrollPosition < InfoSection.current.offsetTop - AppBarHeight()) {
  //     setMenuIndex(2)
  //   }else if (scrollPosition >= InfoSection.current.offsetTop - AppBarHeight() && scrollPosition < FormuSection.current.offsetTop - AppBarHeight()) {
  //     setMenuIndex(3)
  //   }
  // }, [scrollPosition])

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  React.useState(() => {
    function handleWindowResize() {
      setRealwidth([window.innerWidth, window.innerHeight]);
    }
    AOS.init({ duration: 1500 });
    window.addEventListener('resize', handleWindowResize);
  }, [])

  const AppBarHeight = () => {
    
  }

  React.useEffect(() => {
    if (AppBarRef.current != null) {
      setAppBar(AppBarRef.current.offsetHeight + 0)
    }
    setAppBar(window.innerWidth < 900 ? 150 : 250)
  }, [wh])

  const ChangePage = (i) => { // Click menu to change
    setMenuIndex(i)
    if (i == 0) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (i == 1) {
      window.scrollTo({ top: FeatureSection.current.offsetTop - abHeight, behavior: 'smooth' });
    } else if (i == 2) {
      window.scrollTo({ top: TrySection.current.offsetTop - abHeight, behavior: 'smooth' });
    }
  }




  return (
    <>
    {/* <ConsentCom/> */}
    <Box data-aos='fade-in'>
      <img src={border} style={{position: 'fixed', zIndex: 1200, top: 0}} />
      {
        wh[0]< 1000 ? (
<Slide in={true} timeout={600}>
      <AppBar ref={AppBarRef} component="nav" className='appbarcolor' style={{ background: 'transparent', boxShadow: 'none'}}>
        <Toolbar>
          <IconButton
            className='colorbase'
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
        <div style={{flexGrow: 1}}></div>
          <div style={{flexGrow: 1, marginLeft: -30}}>
          <CardMedia src={logo} component='img' sx={{width : window.innerHeight * (28/100), paddingTop: 3}} />
            </div>
        </Toolbar>
      </AppBar>
      </Slide>
        ) : (
          <Slide in={true} timeout={600}>
      <AppBar ref={AppBarRef} component="nav" className='appbarcolor' style={{ background: 'transparent', boxShadow: 'none', paddingTop: 30}}>
        <Toolbar>
        <div style={{flexGrow: 1}}></div>
          <div className='text-center'>
            <CardMedia src={logo} component='img' sx={{width : window.innerHeight * (30/100)}} />
            </div>
            <div style={{flexGrow: 1}}></div>
        </Toolbar>
                <div className='container' style={{marginTop: -60, marginBottom: -20}}>
                  <Grid container>
                      <Grid item xs={12} md={4}>
                          <Button onClick={() => ChangePage(0)}><img src={step1} /></Button>
                      </Grid>
                      <Grid item xs={12} md={4}>
                          <Button onClick={() => ChangePage(1)}><img className='pt-2' src={step2} /></Button>
                      </Grid>
                      <Grid item xs={12} md={4}>
                          <Button onClick={() => ChangePage(2)}><img src={step3} /></Button>
                      </Grid>
                  </Grid>
                </div>
      </AppBar>
      </Slide>
        )
      }


    


      <Box component="nav">
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { md: 'block', lg: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
           <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
              <List>
                  <ListItem className={(menuIndex == 0 ? 'bg-primary bg-header text-light' : '')} onClick={() => ChangePage(0)} disablePadding>
                    <ListItemButton sx={{ textAlign: 'center' }}>
                      <ListItemText primary="พฤติกรรมเข้าข่ายมิจฉาชีพ" />
                    </ListItemButton>
                  </ListItem>
                  <ListItem className={(menuIndex == 1 ? 'bg-primary bg-header text-light' : '')} onClick={() => ChangePage(1)} disablePadding>
                    <ListItemButton sx={{ textAlign: 'center' }}>
                      <ListItemText primary="ช่องทางการสื่อสาร กบข." />
                    </ListItemButton>
                  </ListItem>
                  <ListItem className={(menuIndex == 2 ? 'bg-primary bg-header text-light' : '')} onClick={() => ChangePage(2)} disablePadding>
                    <ListItemButton sx={{ textAlign: 'center' }}>
                      <ListItemText primary="คำแนะนำเมื่อโดนหลอก" />
                    </ListItemButton>
                  </ListItem>
              </List>
            </Box>
        </Drawer>
      </Box>
      <Box component="main" style={{marginTop: abHeight + 30}}>
       <div ref={HomeSection}>
          <HomeCom />
       </div>
       <div ref={FeatureSection} style={{marginTop: 40}}>
          <ContactCom />
       </div>
       <div ref={TrySection} style={{marginTop:  40}}>
       <CheckCom />
       </div>
        {/* <footer className='bg-header fixed-bottom text-light text-center pt-2 pb-2'>
          ติดต่อสอบถาม : <a className='text-light' href='tel:+661179'> Contact Center โทร. 1179</a> <b>|</b> LINE กบข. : <a className='text-light' href='https://lin.ee/pg7w6hn' target='_blank'>@gpfcommunity</a> <b>|</b> เสนอแนะ / ร้องเรียน : <a className='text-light' href='https://www.gpf.or.th' target='_blank'>เมนู "ติดต่อเรา" www.gpf.or.th</a>
        </footer> */}
      </Box>
    </Box>
    
    </>
  );
}

export default App;
